import React, { useEffect, useRef, useState } from 'react';
import { Cross } from '@saleshandy/icons';
import { Progress } from 'reactstrap';
import {
  OverlayPopover,
  Placement,
} from '../../../../../shared/design-system/components/overlay';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';

type IProps = {
  showIntroPopover: boolean;
  setShowIntroPopover: (v: boolean) => void;
};

const ProgressBarComponent = ({ setShowIntroPopover }) => {
  const DURATION = 15; // seconds
  const [timeLeft, setTimeLeft] = useState(DURATION);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timeLeft === 0) return;
    timerRef.current = setTimeout(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 0.25 : 0));
    }, 250);

    // eslint-disable-next-line consistent-return
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [timeLeft]);

  const percentage = (timeLeft / DURATION) * 100;

  if (percentage === 0) {
    setShowIntroPopover(false);
  }

  return <Progress value={percentage} className="sidebar-intro-progress" />;
};

const IntroPopover: React.FC<IProps> = ({
  showIntroPopover,
  setShowIntroPopover,
}) => {
  if (!showIntroPopover) {
    return null;
  }

  return (
    <>
      <div
        className="sidebar-intro-overlay"
        {...accessibleOnClick(() => {
          setShowIntroPopover(false);
        })}
      >
        <OverlayPopover
          className="sidebar-intro-popover"
          show={showIntroPopover}
          onToggle={setShowIntroPopover}
          placement={Placement.Right}
          content={
            <div
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              role="button"
              tabIndex={0}
              className="cursor-default"
            >
              <div className="content">
                Meet Your New <br /> Side Navigation Bar{' '}
                <span role="img" aria-label="rocket">
                  🚀
                </span>
              </div>
              <div
                className="d-flex justify-content-center icon"
                {...accessibleOnClick(() => setShowIntroPopover(false))}
              >
                <Cross />
              </div>
              <ProgressBarComponent setShowIntroPopover={setShowIntroPopover} />
            </div>
          }
        >
          <div className="sidebar-intro" />
        </OverlayPopover>
      </div>
    </>
  );
};

export default IntroPopover;
